module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Communication/Chat-check-01aec3580e91b568402c2d3d0bcd1e65.svg";